import styled from "styled-components";

export const StyledButtons = styled.div`
  border: 2px solid var(--color-light-gray);
  border-radius: 8px;
  background: #fff;
  overflow: hidden;
  box-shadow: 0px 3px 6px #00000029;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 45px;
  position: absolute;
  bottom: 110px;
  left: 20px;

  button {
    border-bottom: 1px solid var(--color-light-gray);
    width: 45px;
    height: 45px;
    cursor: pointer;

    &:last-child {
      border: none;
    }

    &:hover {
      background: rgba(0, 0, 0, 0.05);
    }

    img {
      width: 30px;
    }
  }

  button[aria-label="Reset"] {
    img {
      width: 20px;
    }
  }

  @media (min-width: 640px) {
    width: 33px;
    bottom: 90px;

    button {
      width: 30px;
      height: 30px;

      img {
        width: 20px;
      }

      &[aria-label="Reset"] {
        img {
          width: 15px;
        }
      }
    }
  }
`;
